import { reducer as responsive } from 'react-responsive-redux';

import content from './content/reducers';
import environment from './environment/reducers';
import intl from './intl/reducers';
import notifications from './notifications/reducers';
import page from './page/reducers';
import session from './session/reducers';
import theme from './theme/reducers';
import toasts from './toasts/reducers';
import widgets from './widgets/reducers';

export default {
  content,
  environment,
  intl,
  notifications,
  page,
  responsive,
  session,
  theme,
  toasts,
  widgets,
};
